<template>
  <div>
    <div class="pr-4 pb-4">
      <v-text-field
        light
        label="Title"
        v-model="item.name"
        type="text"
        required
        color="amber"
        placeholder="Name"
      ></v-text-field>

      <v-text-field
        light
        label="Sentence"
        v-model="item.sentence"
        type="text"
        required
        color="amber"
        placeholder="In a sentence"
      ></v-text-field>

      <v-textarea
        light
        label="Context"
        v-model="item.body"
        type="text"
        required
        color="amber"
        placeholder="Description"
        :rows="3"
      ></v-textarea>

      <v-row dense>
        <v-col cols="6">
          <v-select
            light
            :items="colors"
            label="Colour code"
            :value="item.color"
            v-model.trim="item.color"
            item-text="title"
            item-value="color"
            class="mr-4 mt-8"
          ></v-select
        ></v-col>
        <v-col cols="6">
          <v-select
            light
            :items="attrs.listTwo"
            v-model="item.linkedTo"
            :value="item.linkedTo"
            label="Linked to"
            item-text="name"
            item-value="id"
            class="mr-4 mt-8"
            multiple
          ></v-select
        ></v-col>
      </v-row>

      <v-expansion-panels v-model="panel" light class="">
        <v-expansion-panel v-for="list in local.obj" :key="`list-${list.name}`">
          <v-expansion-panel-header>{{ list.title }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-select
              light
              :items="flattenArray(list)"
              :label="list.name"
              :value="item[list.name]"
              v-model.trim="item[list.name]"
              item-text="name"
              item-value="id"
              class="mr-4 mt-8"
              multiple
            ></v-select>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="mr-2" light
        >Change</v-btn
      >
      <v-btn @click="cancel" small color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { itemModel, createItem, customColumns, flattenArray } from "./model";

export default {
  name: "LogicSystemForm",
  components: {},
  props: {
    newItem: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    local: {
      type: Object,
      default: () => {},
    },
    attrs: {
      type: Object,
      deafult: () => {},
    },
  },
  data() {
    return {
      item: this.createItem(this.newItem),
      panel: [0, 1],
      flattenArray: flattenArray,
    };
  },
  computed: {
    getModel() {
      let modelCols = null;
      if (this.local && this.local.obj) {
        modelCols = this.local.obj.map((x) => {
          x.name;
        });
      }
      return modelCols ? modelCols : [];
    },
  },
  mounted() {},
  methods: {
    createItem(item) {
      const a = createItem(item, itemModel);
      const b = customColumns(this?.local?.obj, item);
      return { ...a, ...b };
    },
    submit() {
      this.$emit("submit", this.item);
    },
    cancel() {
      this.$emit("cancel", this.item);
    },
  },
};
</script>
